









import { bookModelProvider } from '../model'
import { defineClassComponent } from '@/hooks'

export default defineClassComponent(
  () =>
    class {
      bookModel = bookModelProvider.inject()
    },
)
